import { isNil } from 'lodash';
import React, { useContext } from 'react';
import { Switch as RNSwitch, SwitchProps } from 'react-native';
import { ColorThemeContext } from '@shared/styles';

export function Switch(props: SwitchProps) {
  const colors = useContext(ColorThemeContext);

  const trackColorEnabled = {
    true: colors.accentInactive,
    false: colors.input.borderInactive,
  };
  const trackColorDisabled = {
    true: colors.accentInactiveDeemphasized,
    false: colors.input.borderInactive,
  };

  const thumbColor = () => {
    if (props.value) {
      return !!props.disabled ? colors.accentInactive : colors.accent;
    } else {
      return !!props.disabled ? colors.backgroundInactive : colors.accentInactive;
    }
  };
  const switchProps = {
    thumbColor: thumbColor(),
    trackColor: !isNil(props.trackColor)
      ? props.trackColor
      : !!props.disabled
      ? trackColorDisabled
      : trackColorEnabled,
    // Make the Switch component consume touch events so that the
    // MBTouchableOpacity from MBFormFieldBase doesn't _also_ receive
    // them. Otherwise we'd both toggle the switch and call onPress above.
    onStartShouldSetResponder: () => true,
    style: { cursor: props.disabled ? 'default' : 'pointer' },
    onValueChange: props.disabled ? () => {} : props.onValueChange,
    disabled: false,
  } as any;

  const switchWebProps = {
    activeThumbColor: !!props.disabled ? colors.accentInactive : colors.accent,
    activeTrackColor: !!props.disabled ? colors.accentInactiveDeemphasized : colors.accentInactive,
  };

  return <RNSwitch {...props} {...switchProps} {...switchWebProps} />;
}
